import { toTwoDigit } from './toTwoDigits';

export function formatSeconds(seconds: number) {
  return `00 : ${toTwoDigit(seconds)}`;
}
